import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "release_share_modal_mask"
}
const _hoisted_2 = { class: "release-share-modal" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "release-share-modal-header" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "header-img",
    src: "/static/image/release/fix.svg"
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "header-text" }, "プレスリリースが公開されました")
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "release-share-modal-topic" }, [
  /*#__PURE__*/_createTextVNode("プレスリリースの作成、お疲れさまです。"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("さっそく公開したプレスリリースをシェアして、"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("一人でも多くの方に見てもらいましょう！")
], -1)
const _hoisted_5 = { class: "release-share-modal-text" }
const _hoisted_6 = { class: "release-share-modal-time" }
const _hoisted_7 = { class: "release-share-modal-text" }
const _hoisted_8 = { class: "release-share-modal-share" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  class: "curation-icon",
  src: "/static/image/corporation/icon_x_bk.svg",
  alt: ""
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode("ツイートする")
const _hoisted_11 = [
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fab fa-facebook-square curation-icon" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("シェアする")
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.state.isShowReleaseShareModal)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.state.article.title), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.state.article.showSendDate()), 1),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", {
                class: "button",
                href: "#",
                rel: "nofollow",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openSnsShareWindow(_ctx.twitterShareUrl, 'tweetWindow', 575, 400)))
              }, _hoisted_11),
              _createElementVNode("a", {
                class: "button",
                href: "#",
                rel: "nofollow",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openSnsShareWindow(_ctx.faceBookShareUrl, 'facebookWindow', 575, 400)))
              }, _hoisted_14)
            ])
          ]),
          _createElementVNode("a", {
            class: "close",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closeModal()))
          })
        ])
      ]))
    : _createCommentVNode("", true)
}